.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: var(--play-button-control-size);
}

.controls {
  display: flex;
  justify-content: space-between;
  width: 100%;

  button {
    padding: 0;

    svg {
      width: var(--play-button-control-size);
      height: var(--play-button-control-size);
      color: var(--gray-700);

      &:hover {
        color: var(--gray-900);
      }
    }

    &:disabled {
      svg {
        color: var(--gray-400);
      }
    }
  }
}
